import styled from '@emotion/styled'
import { ssrWarning } from 'utils/emotion'

const withStyle = (ListContainer) =>
  styled(ListContainer)((props) => {
    const { column, doOffAxisMargins } = props
    // #root is needed because some Antd styles include it.
    return column
      ? `
        #root &&>:first-child ${ssrWarning} {
          margin-top: 0;
        }
        #root &&>:last-child ${ssrWarning} {
          margin-bottom: 0;
        }
        #root &>* {
           display: block;
        }
        #root &&&>* {
           margin-left: ${doOffAxisMargins ? '' : 0};
           margin-right: ${doOffAxisMargins ? '' : 0};
        }
        `
      : `
        #root &&>:first-child ${ssrWarning} {
          margin-left: 0;
        }
        #root &>:last-child {
          margin-right: 0;
        }
        #root &>* {
           display: inline-block;
        }
        #root &&&>* {
           margin-top: ${doOffAxisMargins ? '' : 0};
           margin-bottom: ${doOffAxisMargins ? '' : 0};
        }
      `
    // Not sure why above margin-top didn't get prioritized.
  })

export default withStyle
